var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackStars10(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "black-stars-10_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 87 14",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".black-stars-10_svg__st0{fill:#1c1c1c}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "black-stars-10_svg__st0",
    d: "M7.7.6l1.6 4.9h5.1l-4.1 3 1.6 4.9-4.1-3-4.1 3 1.6-4.9-4.3-3h5.1L7.7.6zM25.6.6l1.6 4.9h5.1l-4.1 3 1.6 4.9-4.1-3-4.1 3 1.6-4.9-4.1-3H24L25.6.6zM43.5.6l1.6 4.9h5.1l-4.1 3 1.6 4.9-4.1-3-4.1 3L41 8.5l-4.1-3H42L43.5.6zM61.1.6l1.6 4.9h5.1l-4.1 3 1.6 4.9-4.1-3-4.1 3 1.6-4.9-4.1-3h5.1L61.1.6zM78.6.6l1.6 4.9h5.1l-4.1 3 1.6 4.9-4.1-3-4.1 3 1.6-4.9-4.1-3H77L78.6.6z"
  })));
}
export default SvgBlackStars10;